module.exports = require("class-transformer");